<template>
  <v-container>
    <v-card
      color="#efefef"
      class="mb-12"
    >
      <v-row class="px-5 ">
        <v-col
          cols="12"
        >
          <!-- <v-switch
            v-model="tipcol"
            class="ml-4"
            :label="`Multicolore `"
            @change="set_tipcol"
          >
            <template v-slot:label>
              <span
                v-if="tipcol"
                class="text-h2 font-light-weight ml-6"
                style="color:#4caf50"
              ><b>Multicolore</b></span>
              <span
                v-else
                class="text-h2 font-light-weight ml-6"
                style="color:#888"
              >Monocolore</span>
            </template>
          </v-switch> -->

          <v-row>
            <v-col
              cols="12"
            >
              <v-form
                ref="form"
                v-model="validForm"
              >
                <v-row
                  v-for="(piece,idx) in toColorize"
                  :key="`piece_${idx}`"
                  justify="center"
                  class="ma-0 pa-0"
                >
                  <v-col class="text-md-end my-0 py-0          ">
                    {{ piece.lbl }}
                  </v-col>
                  <v-col
                    md="10"
                    cols="12"
                    class="my-0 py-0"
                  >
                    <!--   {{ colori }} -->
                    <v-autocomplete
                      v-model="steporder[piece.var]"
                      :items="colori.filter(item => (item.compo === piece.compo && item.tipcompo === piece.tipcompo))"
                      :rules="[rules.required]"
                      outlined
                      color="blue-grey lighten-2"
                      label=""
                      item-text="finder"
                      return-object
                      clearable
                      class="my-0 py-0 text-body-1"
                      dense
                    >
                      <template v-slot:selection="data">
                        <v-avatar
                          rounded
                          left
                        >
                          <v-img
                            :src="`./img/COL/${$linea().label}_${data.item.numcol}.png`"
                            contain
                          />
                        </v-avatar>
                        <span class="pl-4">{{ data.item.numcol }} {{ data.item.codcol }} {{ data.item.coldesc }}</span>
                      </template>
                      <template
                        v-slot:item="data"
                      >
                        <v-list-item-avatar
                          rounded
                          width="30"
                        >
                          <v-img
                            :alt="` avatar`"
                            :src="`./img/COL/${$linea().label}_${data.item.numcol}.png`"
                            :lazy-src="'./img/noimage.jpg'"
                            contain
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            class="pl-4"
                            v-text="`${data.item.numcol} ${data.item.codcol} ${data.item.coldesc}` "
                          />
                          <v-list-item-subtitle class="d-none">
                            ./img/COL/{{ $linea().label }}_{{ data.item.numcol }}.png
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row
                  justify="center"
                  class="ma-0 pa-0"
                >
                  <v-col class="text-md-end my-0 py-0          ">
                    Terminale
                  </v-col>
                  <v-col
                    md="10"
                    cols="12"
                    class="my-0 py-0"
                  >
                    <v-autocomplete
                      v-model="steporder.vlterm"
                      outlined
                      dense
                      :items="colori.filter(item => (item.compo === 'TERM'))"
                      :rules="[rules.required]"
                      color="blue-grey lighten-2"

                      item-text="tipcompo"
                      return-object
                      clearable
                      class="ma-0 pa-0 text-body-1"
                      @change="$set(steporder, 'fascia', 'NO')"
                    >
                      <template v-slot:selection="data">
                        <v-avatar
                          rounded
                          left
                          width="55"
                        >
                          <v-img
                            :src="`./img/TERM/${$linea().label}_${data.item.tipcompo}.png`"
                            contain
                          />
                        </v-avatar>

                        <span class="pl-4">{{ data.item.descompo }}</span>
                      </template>
                      <template
                        v-slot:item="data"
                      >
                        <v-list-item-avatar
                          rounded
                          width="80"
                          height="auto"
                        >
                          <v-img
                            :src="`./img/TERM/${$linea().label}_${data.item.tipcompo}.png`"
                            contain
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <span class="pl-4"> {{ data.item.descompo }} </span>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                    <template v-if="[2,3].includes(+steporder?.vlterm?.tipcompo)">
                      <v-checkbox
                        v-model="steporder.fascia"
                        dense
                        hide-details
                        true-value="SI"
                        false-value="NO"
                        :label="`Fascia elastica inclusa? ${steporder.fascia}`"
                        color="primary"
                      />
                    </template>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-btn
      color="primary"
      :disabled="!validForm "
      @click="setColCompo"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Step3',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {

        steporder: {},
        colori: [],
        // colori_clp: [],
        tipcol: false,
        validForm: false,
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      toColorize () {
        // if (!this.order?.tippon?.tipcompo || !this.order?.vlaste?.tipcompo) {
        //   return []
        // }

        /**
         *  dogma frontale non più valido dal 05.03.2026 in accordo con valentina
         *    se joy  tipcompo=44
         *    se joybaby tipcompo=34
         * this.order?.lens?.calibr?.split('-')[1] || '34'
         */
        var taglia = this.order.lens?.calibr?.split('-')[0]
        var tpcmp
        switch (taglia) {
          case 'XS':
            tpcmp = '34'
            break
          case 'S':
            tpcmp = '36'
            break
        }

        if (this.tipcol) {
          return [
            { compo: 'FRON', tipcompo: tpcmp, lbl: 'FRONTALE', var: 'col_fronta' },
            { compo: 'ASTE', tipcompo: this.order.vlaste.tipcompo, lbl: 'ASTA DX', var: 'col_astadx' },
            { compo: 'ASTE', tipcompo: this.order.vlaste.tipcompo, lbl: 'ASTA SX', var: 'col_astasx' },

          ]
        } else {
          return [
            { compo: 'FRON', tipcompo: tpcmp, lbl: 'MONTATURA', var: 'col_fronta' },
            { compo: 'PNAS', tipcompo: '1', lbl: 'Porta Nasello', var: 'col_pornas' },
          ]
        }
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     console.log('Order changed from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        console.log('load>>', this.$options.name, stp)
        if (this.$options.name === `Step${stp}`) {
          console.log('success load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (this.colori.length === 0) {
            this.loadColCompo()
          }
          if (typeof this.steporder.fascia === 'undefined') {
            this.$set(this.steporder, 'fascia', 'NO')
          }

          // JoyBaby ha solo monocolore
          // this.tipcol = this.steporder.tipcol
        }
      },
      nextStep () {
        if (!this.validForm) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        this.$emit('prevStep', this.step)
      },
      loadColCompo () {
        this.loading = true
        engine.get_colcompo(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            this.colori = result.data
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })
      },
      set_tipcol () {
        this.steporder.tipcol = this.tipcol
      },
      setColCompo () {
        // colore terminale
        // var colTermin = this.colori.filter(item => (item.compo === 'TERM' && item.tipcompo === this.steporder.vlterm.tipcompo))
        // if (colTermin.length > 1) {
        //   alert('indicare colore terminale sulle annotazione')
        // }
        // if (colTermin.length === 1) {
        //   this.steporder.col_termin = colTermin[0]
        // }

        if (!this.tipcol) {
          this.steporder.col_astadx = this.steporder.col_fronta
          this.steporder.col_astasx = this.steporder.col_fronta
        }
        this.nextStep()
      },

    },
  }
</script>
